import { openBlock as o, createElementBlock as r, createElementVNode as t } from "vue";
import n from "../_virtual/_plugin-vue_export-helper.mjs";
const l = {}, s = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "25",
  height: "24",
  viewBox: "0 0 25 24",
  fill: "none"
};
function c(i, e) {
  return o(), r("svg", s, e[0] || (e[0] = [
    t("rect", {
      x: "2.7",
      y: "3.2",
      width: "18.6",
      height: "18.6",
      rx: "4.8",
      stroke: "currentColor",
      "stroke-width": "1.6"
    }, null, -1),
    t("path", {
      d: "M15.5355 9.03553L8.46447 16.1066M8.46447 9.03553L15.5355 16.1066",
      stroke: "currentColor",
      "stroke-width": "1.6",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]));
}
const u = /* @__PURE__ */ n(l, [["render", c]]);
export {
  u as default
};
